/**
 * Allows us to use the documentMode for feature detection on globalThis.Document
 */
declare global {
    interface Document {
        documentMode?: any;
    }

    interface Window {}
}
/**
 * Returns true if the detected browser is IE.
 * @returns boolean
 */
const _isIE = (): boolean => {
    return /*@cc_on!@*/ false || !!document.documentMode;
};

const isTouchscreenDevice = (): boolean => {
    return !window.matchMedia("(hover: hover) and (pointer: fine)");
};

const isMouseDevice = (): boolean => {
    return matchMedia("(pointer:fine)").matches;
};

export const BrowserUtils = {
    isIE: _isIE,
    isTouchscreenDevice,
    isMouseDevice,
};
